import { z } from 'zod';
import { OmniFieldDefinitionSchema } from './omni/fields.js';
export const analyticsFieldSearchLimits = { fields: 50 };
export const AnalyticsFieldSearchSchema = z.strictObject({
    search: z
        .string()
        .trim()
        .min(1)
        .max(200)
        .describe('Keywords or a native field identifier. All whitespace-separated terms must occur in the field name, label or description, ignoring case. This is keyword search, not semantic search.'),
    kind: OmniFieldDefinitionSchema.shape.kind.optional(),
    limit: z.coerce.number().int().min(1).max(analyticsFieldSearchLimits.fields).default(20),
});
export const AnalyticsFieldSearchResponseSchema = z.strictObject({
    fields: z.array(OmniFieldDefinitionSchema).max(analyticsFieldSearchLimits.fields),
    truncation: z
        .literal('fieldLimit')
        .nullable()
        .describe('Null when all matches fit. Narrow the search or field kind when truncated.'),
});
//# sourceMappingURL=fields.js.map